//
//
//
//
//
//
//
//
//
//

import RbFrameAdvisor from '../frame-advisor/frame-advisor.lazy.vue'

import { createNamespacedHelpers } from 'vuex'
import { SizeAdvisor } from '@/scripts/libs/size-advisor'
import { FrameAdvisor } from '@/scripts/libs/frame-advisor'
const { mapGetters: mapGettersPdp } = createNamespacedHelpers('pdp')

export default {
  name: 'rb-size-advisor',
  extends: RbFrameAdvisor,
  props: {
    trigger: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    // TODO: Extract selectedProduct as a prop
    ...mapGettersPdp(['selectedProduct']),
    isSizeAdvisorRunning() {
      return this.isSizeAdvisorOpen
    },
  },
  watch: {
    trigger(next, prev) {
      if (next !== prev) {
        this.openSizeAdvisor()
      }
    },
  },
  mounted() {
    window.externalInvocationMethodMapping.initSizeAdvisor = async () => {
      this.openSizeAdvisor()
    }
  },
  methods: {
    openSizeAdvisor() {
      if (!this.isSizeAdvisorRunning) {
        this.setWhiteLabelStatus(true)
        this.$nextTick(() => {
          SizeAdvisor.trackSizeAdvisorOpenEvent(this.$ma)
          SizeAdvisor.addSizeAdvisorHashPath()
          this.loadAndInitWhiteLabel()
          this.setWhiteLabelStatus(true)
        })
      }
    },
    setWhiteLabelStatus(status) {
      this.setSizeAdvisorStatus(status)
    },
    renderWhiteLabelApplication(config) {
      config.selector = '#sizeadv-ui'
      config.startMinimized = false
      return window.frameAdvisor.SizeAdvisorWidget.new(config)
    },
    registerWhiteLabelEvents(config) {
      config.handleResults = (results) => {
        const sizeAdvisorResult = { size: results }
        FrameAdvisor.setAnalysisResults(sizeAdvisorResult)
        SizeAdvisor.setSizeAdivsorPlpToggleStatus(true)

        this.setFrameGeniusAnalysisResults(sizeAdvisorResult)
        this.$emit('onSizeAdvisorSuggestion', sizeAdvisorResult)
        this.setWhiteLabelStatus(false)
        this.whiteLabelWidget.closeApp()
      }
    },
    saveFrameSuggestionData() {
      return
    },
    registerFrameGeniusEvents() {
      document.body.addEventListener('sa-maximize', this.onFaMaximise)
      document.body.addEventListener('sa-minimize', this.onFaMinimise)
      document.body.addEventListener('sa-close', this.onFaClose)
    },
    onFaMinimise() {
      this.onFaClose()
    },
    onFaMaximise() {
      return
    },
    onFaClose() {
      this.setWhiteLabelStatus(false)
      this.whiteLabelWidget.closeApp()
    },
  },
}
